import { useRouter } from 'vue-router'

export type ProfileTabName = 'profile' | 'security' | 'notifications' | 'api'

const TABS: { label: string; name: ProfileTabName; route: string }[] = [
  { label: 'Profile', name: 'profile', route: 'profile' },
  { label: 'Security', name: 'security', route: 'profile-security' },
  {
    label: 'Notifications',
    name: 'notifications',
    route: 'profile-notifications'
  },
  { label: 'API', name: 'api', route: 'profile-api' }
]

export function useProfileTabs() {
  const router = useRouter()

  function open(name: string) {
    const tab = TABS.find((item) => item.name === name)

    if (tab) router.push({ name: tab.route })
  }

  return { tabs: TABS, open }
}
